import { Divider, Fab, Paper, Tooltip, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";
import { Employee } from "../../graphql/baseTypes";
import { LoadingIndicator } from "../Loading";
import EmployeeListItem from "./EmployeeListItem";
interface Props {
  items: Array<Employee>;
  loading?: boolean;
  loadMore?: () => any;
  hasMore?: boolean;
  openDialog: () => any;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      marginTop: 40,
    },
    paper: {
      padding: "40px 60px",
      width: "100%",
      flexDirection: "column",
      marginTop: 20,
    },
    header: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      flex: 1,
      justifyContent: "space-between",
      paddingBottom: theme.spacing(2),
    },
  })
);
const EmployeeList: React.FC<Props> = ({
  items,
  loading,
  hasMore = false,
  loadMore = () => {},
  openDialog,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <Typography variant="h5">Testpersonendaten</Typography>
          <Tooltip title="Testpersonendaten für Standort anlegen">
            <Fab
              aria-label="create employee"
              size={"small"}
              disabled={loading}
              onClick={openDialog}
              color={"primary"}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        </div>
        <Divider />
        <List component="ul" aria-label="primary-Employee-list">
          {items.length === 0 && !loading && (
            <h5>Keine Testpersonendaten gefunden</h5>
          )}
          {loading && <Skeleton count={5} height={50} />}
          {!loading && (
            <InfiniteScroll
              dataLength={items.length}
              loader={<LoadingIndicator />}
              next={loadMore}
              hasMore={hasMore}
            >
              {items.map((item, index) => (
                <EmployeeListItem
                  key={index}
                  item={item}
                  isLast={index === items.length - 1}
                />
              ))}
            </InfiniteScroll>
          )}
        </List>
      </Paper>
    </div>
  );
};

export default EmployeeList;
